import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Instagram } from "lucide-react";

const REASONS = {
  invalid_state: "The session expired or was tampered with. Please try connecting again.",
  no_code: "Instagram didn't return an authorization code.",
  not_configured: "Instagram login isn't configured on this store yet.",
  exchange_failed: "We couldn't verify your Instagram account. Please try again.",
  access_denied: "You cancelled the Instagram connection.",
};

export default function OnboardingInstagram() {
  const [params] = useSearchParams();
  const status = params.get("status");
  const handle = params.get("handle");
  const reason = params.get("reason");
  const ok = status === "ok";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] px-6" data-testid="ig-onboarding">
      <div className="max-w-md w-full text-center text-white">
        <div className="mx-auto h-16 w-16 rounded-2xl flex items-center justify-center mb-6"
          style={{ background: "linear-gradient(135deg,#833ab4,#fd1d1d,#fcb045)" }}>
          <Instagram size={30} />
        </div>
        {ok ? (
          <>
            <CheckCircle2 size={44} className="mx-auto text-emerald-400 mb-4" />
            <h1 className="font-heading text-3xl font-light mb-2" data-testid="ig-onboarding-success">You're connected 🎉</h1>
            <p className="text-white/60 mb-6">
              We imported your Instagram profile and created a draft storefront
              {handle ? <> at <span className="font-mono text-[#ccff00]">/{handle}</span></> : ""}.
              Our team will review it and reach out to help you go live.
            </p>
          </>
        ) : (
          <>
            <XCircle size={44} className="mx-auto text-rose-400 mb-4" />
            <h1 className="font-heading text-3xl font-light mb-2" data-testid="ig-onboarding-error">Connection failed</h1>
            <p className="text-white/60 mb-6">{REASONS[reason] || "Something went wrong connecting your Instagram account."}</p>
          </>
        )}
        <Link to="/" data-testid="ig-onboarding-home"
          className="inline-block bg-white text-black rounded-full px-7 py-3 font-semibold active:scale-95 transition-transform">
          Back to StoreIG
        </Link>
      </div>
    </div>
  );
}
